import { render } from "./clients.vue?vue&type=template&id=d1d899dc"
import script from "./clients.vue?vue&type=script&lang=js"
export * from "./clients.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__